export const mejoraRegulatoria = [
  {
    item_nombre: "Programa Anual de Mejora Regulatoria",
    item_url: "../contenido/transparencia/mejoraregulatoria/Mejora_Regulatoria_2026_SALUD.pdf",
    item_descripcion: "2026"
  },
  {
    item_nombre: "Programa Anual de Mejora Regulatoria",
    item_url: "../contenido/transparencia/mejoraregulatoria/Mejora_Regulatoria_2025_SALUD.pdf",
    item_descripcion: "2025"
  },
  {
    item_nombre: "Programa Anual de Mejora Regulatoria",
    item_url: "../contenido/transparencia/mejoraregulatoria/Mejora_Regulatoria_2024_SALUD.pdf",
    item_descripcion: "2024"
  },
];